import * as info from './info';

export default {
  ...info,
};
